import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import { Link, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Divider, IconButton, useMediaQuery } from '@mui/material';
import myLogo from "../../assets/logo.jpg";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)(({ theme, open, isSmallScreen }) => ({
  width: open ? drawerWidth : isSmallScreen ? 0 : `calc(${theme.spacing(7)} + 1px)`,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  '& .MuiDrawer-paper': {
    width: open ? drawerWidth : isSmallScreen ? 0: `calc(${theme.spacing(7)} + 1px)`,
    overflowX: 'hidden',
  },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const isActiveRoute = (currentPath, targetPath) =>
  currentPath.startsWith(targetPath);

const Sidebar = ({ open, setOpen, drawerItems }) => {
  const theme = useTheme();
  const location = useLocation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // Move useState to the top of the component
  const [expandedSections, setExpandedSections] = useState({});

  const toggleNested = (path) => {
    setExpandedSections((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  const expandNested = (path) => {
    setExpandedSections((prev) => ({
      ...prev,
      [path]: true,
    }));
  };

  const renderDrawerItems = (open, setOpen, items, parentPath = '') =>
    items.map((item) => {
      const fullPath = parentPath + item.path;
      const isExpanded = expandedSections[fullPath] || false;

      return (
        <React.Fragment key={item.path}>
          <ListItem disablePadding>
            <ListItemButton
              component={!item.nested ? Link : 'button'} // Link for non-nested items, button for expandable
              to={!item.nested ? fullPath : undefined} // Only add "to" for non-nested items
              onClick={() => {
                //console.log(item,expandedSections,fullPath)
                if (!open && !item.nested) return;
                if (!open) {
                  setOpen(true)
                  expandNested(fullPath);
                  return;
                };
                if (open && !item.nested) setOpen(false);
                if (item.nested) toggleNested(fullPath); // Expand/collapse for nested items
              }}
              sx={{
                ...(isActiveRoute(location.pathname, fullPath) && {
                  borderLeft: parentPath===''?'4px solid red':null,
                  borderRight: parentPath!==''?'4px solid red':null,
                  backgroundColor: theme.palette.action.selected,
                  color: 'red',
                }),
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} />
              {item.nested && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </ListItem>
          {open && isExpanded && item.nested && (
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{marginLeft:'12px'}}>
                {renderDrawerItems(open, setOpen, item.nested, fullPath)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });

  return (
    <Drawer variant={isSmallScreen?"":"permanent"} open={open} isSmallScreen={isSmallScreen}>
      <DrawerHeader sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> 
          <div></div>
          <div>
            <img src={myLogo} alt="LOGO" width={'120px'} />
          </div>
          <IconButton onClick={_=>setOpen(false)}>
            {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </DrawerHeader>
        <Divider />
      <List>{renderDrawerItems(open, setOpen, drawerItems)}</List>
    </Drawer>
  );
};

export default Sidebar;
